import { useEffect, useState } from "react";
import { Controller, useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";

import { IconSearchLg } from "@pentabd/icons";
import { InputText, Switch, Table, Text } from "@pentabd/ui";

import { usePermissions } from "@hooks/HRM/role-management/usePermissions";

import { SelectedData } from "@helpers/watchSwitchGroups";

export const AssignPermissionTable = () => {
  const [newData, setNewData] = useState<any>(null);

  const { register, setValue, control } = useFormContext();
  const { permissions } = usePermissions();
  const { t } = useTranslation();

  useEffect(() => {
    setNewData(permissions);
  }, [permissions]);

  const searchEffect = (searchParams: string) => {
    if (searchParams) {
      const updatedData = permissions.filter((permission: any) =>
        permission.name
          .replace(/_/g, " ")
          .toUpperCase()
          .includes(searchParams.replace(/_/g, " ").toUpperCase()),
      );
      setNewData(updatedData);
    } else {
      setNewData(permissions);
    }
  };

  return (
    <Table
      columns={[
        {
          id: 1,
          key: "name",
          name: t("POSITION.FORM.TABLE.ASSIGN_PERMISSION.COLUMN_NAME"),
          render: (newData) => (
            <Text size="sm" weight="normal" color="subtitle1">
              {newData}
            </Text>
          ),
        },
        {
          id: 2,
          key: "id",
          name: "",
          render: (id, row) => (
            <div className="d-flex justify-content-end pe-16">
              <Controller
                control={control}
                name={`permissions.${id}`}
                key={`permissions.${id}`}
                render={({ field }) => {
                  return (
                    <Switch
                      {...register(`permissions.${id}`)}
                      value={JSON.stringify(row)}
                      key={`permissions.${id}`}
                      id={`permissions.${id}`}
                      name="permissions"
                      size="sm"
                      controlling
                      onChange={(e) => {
                        if (field.value) {
                          setValue(`permissions.${id}`, false);
                        } else
                          setValue(
                            `permissions.${id}`,
                            JSON.parse(e.target.value),
                          );
                      }}
                    />
                  );
                }}
              />
            </div>
          ),
        },
      ]}
      rows={newData}
      header={{
        badge: {
          label: `${
            SelectedData("permissions") ? SelectedData("permissions").length : 0
          }`,
          size: "sm",
          type: "primary",
        },
        title: t("POSITION.FORM.TABLE.ASSIGN_PERMISSION.HEADING"),
        buttons: [
          <InputText
            key={1}
            name="pre-input"
            outline
            placeholder={t("POSITION.FORM.TABLE.ASSIGN_PERMISSION.SEARCH")}
            prefix={<IconSearchLg width="18" height="18" fill="dark" />}
            size="md"
            type="text"
            status="default"
            onChange={(e) => searchEffect(e.target.value)}
            controlling
          />,
        ],
      }}
    />
  );
};
